import { render, staticRenderFns } from "./Naplata.vue?vue&type=template&id=83385d62&scoped=true&"
import script from "./Naplata.vue?vue&type=script&lang=js&"
export * from "./Naplata.vue?vue&type=script&lang=js&"
import style0 from "./Naplata.vue?vue&type=style&index=0&id=83385d62&prod&scoped=true&lang=css&"
import style1 from "./Naplata.vue?vue&type=style&index=1&id=83385d62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83385d62",
  null
  
)

export default component.exports